export const ANALYTICS_FILTER_ID = "ANALYTICS_FILTER_ID";
export const BLOGGERS_FILTER_ID = "BLOGGERS_FILTER_ID";
export const RESTAURANTS_FILTER_ID = "RESTAURANTS_FILTER_ID";
export const CANDIDATE_FORMS_ROWS_FILTER_ID = "CANDIDATE_FORMS_ROWS_FILTER_ID";
export const CANDIDATE_FORMS_ORDER_FILTER_ID = "CANDIDATE_FORMS_ORDER_FILTER_ID";
export const INTERVIEW_FILTER_ID = "INTERVIEW_FILTER_ID";
export const AD_COMPANIES_FILTER_ID = "AD_COMPANIES_FILTER_ID";
export const USER_MANAGEMENT_FILTER_ID = "USER_MANAGEMENT_FILTER_ID";